export interface HelpSection {
  id: string
  title: string
  body: string
}

/** Splits a markdown document on its `## ` headings. Text before the first heading is dropped. */
export function splitSections(markdown: string): HelpSection[] {
  return markdown
    .split(/^## /m)
    .slice(1)
    .map((part) => {
      const newline = part.indexOf("\n")
      const title = (newline === -1 ? part : part.slice(0, newline)).trim()
      const body = newline === -1 ? "" : part.slice(newline + 1).trim()
      const slug = title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")
      return { id: `help-${slug}`, title, body }
    })
}
